import Button from '../../../../components/Button/Button';
import Constants from 'expo-constants';
import Loading from '../../../../components/Loading/Loading';
import Show from '../../../../components/Show/Show';
import StaticFrame from '../../../../components/Frames/StaticFrame/StaticFrame';
import styled from '../../../../utils/style/styled';
import { COLORS } from '../../../../config/designSystem/Colors';
import { FC, useEffect } from 'react';
import {  Image, Linking } from 'react-native';

import Images from '../../../../state/stores/Image/images';
import { InstantHelpStackParamList } from '../../../../types/navigation';
import { InstantHelpVideo } from '../../../../components/Assistance/InstantHelpVideo';
import { isWeb } from '../../../../config/designSystem/Layout';
import { observer } from 'mobx-react';
import { useGlobalSearchParams } from 'expo-router';
import { useStores } from '../../../../hooks/useStores';
import { useVideoPermissions } from '../../../../components/QuestionSessions/QuestionSession/useSpecificOnNextLogic';

const Frame = styled.View`
  flex: 1;
  justify-content: flex-start;
  align-items: center;
  margin-top: ${isWeb ? 0 : Constants.statusBarHeight}px;
  margin-bottom: ${isWeb ? 0 : 32}px;
  margin-horizontal: 16px;
  background-color: '${COLORS.surface.primary}';
  opacity: 1;
`;


type InstantHelpVideoProps = InstantHelpStackParamList['Videocall'];


const InstantHelpVideoWithPermissionWrapper  : FC<InstantHelpVideoProps> = observer(() => {

  const {granted, asking, requestPermissions, canAskAgain} = useVideoPermissions();
  const {  language: languageStore} = useStores();
  const labels = languageStore.translate?.MOBILE?.ASSISTANCE?.CALL;
  const params = useGlobalSearchParams();

  const openSettings = () => {
    Linking.openSettings();
  };

  useEffect(() => {
    if(!granted && canAskAgain && !asking) {
      requestPermissions();
    }

  }, [granted, canAskAgain, asking]);


  return (
    <>
      <Show when={!granted && !canAskAgain && !asking}>
        <Frame>
          <StaticFrame
            staticFrame={{
              mainTitle: labels?.PERMISSIONS_REQUIRED,
              secondaryTitle: labels?.PERMISSIONS_REQUIRED_VIDEO,
            }}
            renderImage={props => (
              <Image
                source={Images.assistance.assistance_therapy}
                {...props}
              />
            )}
          />
          <Show when={!isWeb}>
            <Button
              onPress={openSettings}
              label={labels?.OPEN_APP_SETTINGS}
            />
          </Show>
        </Frame>
      </Show>
      <Show when={asking}>
        <Loading label={labels?.PERMISSIONS_REQUIRED_VIDEO} />
      </Show>
      <Show when={granted }>
        <InstantHelpVideo timeStamp={params?.timeStamp} />

      </Show>
    </>
  );
});

export default InstantHelpVideoWithPermissionWrapper;
